// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__37xcW","header":"ClearentDisclaimer_header__zYJnc","inner":"ClearentDisclaimer_inner__1YY9l"};